import { Link } from "react-router-dom";
import { Instagram, MessageCircle, Phone, MapPin } from "lucide-react";
import { CONTACT, WHATSAPP_URL, TEL_URL, SERVICES } from "../data/site";

export default function Footer() {
    return (
        <footer
            data-testid="site-footer"
            className="bg-[#08080a] border-t border-[#23232b] pt-14 pb-8 relative overflow-hidden"
        >
            <div className="absolute -bottom-40 left-1/2 -translate-x-1/2 w-[800px] h-[400px] rounded-full bg-[#c9a24b]/6 blur-[130px] pointer-events-none" />

            <div className="container-x relative">
                <div className="grid lg:grid-cols-12 gap-10 lg:gap-8">
                    <div className="lg:col-span-4">
                        <div className="flex items-center gap-3">
                            <div className="w-11 h-11 rounded-full overflow-hidden bg-black ring-1 ring-[#c9a24b]/45">
                                <img
                                    src={CONTACT.logoUrl}
                                    alt="Cegu Logo"
                                    className="w-full h-full object-cover logo-blend"
                                    loading="lazy"
                                />
                            </div>
                            <div>
                                <div className="text-[15px] font-semibold gold-text">
                                    Ce&Gu Masaj
                                </div>
                                <div className="text-[10.5px] uppercase tracking-[0.28em] text-[#7d766a] mt-0.5">
                                    Özlüce · Bursa
                                </div>
                            </div>
                        </div>
                        <p className="mt-5 text-[13.5px] leading-relaxed text-[#b8b1a1] max-w-sm">
                            Bursa Nilüfer Özlüce'de profesyonel masaj ve wellness
                            hizmeti. Uzman terapistler, hijyenik salon ortamı,
                            hızlı WhatsApp randevusu.
                        </p>

                        <div className="mt-6 flex items-center gap-2">
                            {[
                                {
                                    icon: MessageCircle,
                                    href: WHATSAPP_URL,
                                    l: "WhatsApp",
                                },
                                { icon: Phone, href: TEL_URL, l: "Phone" },
                                {
                                    icon: Instagram,
                                    href: CONTACT.instagram,
                                    l: "Instagram",
                                },
                                {
                                    icon: MapPin,
                                    href: CONTACT.mapLink,
                                    l: "Map",
                                },
                            ].map((s, i) => {
                                const I = s.icon;
                                return (
                                    <a
                                        key={i}
                                        href={s.href}
                                        target="_blank"
                                        rel="noreferrer"
                                        aria-label={s.l}
                                        data-testid={`footer-social-${s.l.toLowerCase()}`}
                                        className="w-10 h-10 rounded-full border border-[#23232b] flex items-center justify-center text-[#c9c2b3] hover:text-[#0a0a0c] hover:bg-gradient-to-br hover:from-[#f5d685] hover:to-[#8a6a28] hover:border-transparent transition"
                                    >
                                        <I className="w-4 h-4" />
                                    </a>
                                );
                            })}
                        </div>
                    </div>

                    <div className="lg:col-span-3">
                        <div className="text-[10.5px] uppercase tracking-[0.28em] gold-text mb-4">
                            Hizmetler
                        </div>
                        <ul className="space-y-2.5">
                            {SERVICES.slice(0, 6).map((s) => (
                                <li key={s.slug}>
                                    <Link
                                        to={`/hizmet/${s.slug}`}
                                        className="text-[13.5px] text-[#c9c2b3] hover:text-[#f5d685] transition"
                                    >
                                        {s.seoTitle}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div className="lg:col-span-3">
                        <div className="text-[10.5px] uppercase tracking-[0.28em] gold-text mb-4">
                            İletişim
                        </div>
                        <div className="space-y-2.5 text-[13.5px]">
                            <a
                                href={TEL_URL}
                                className="block text-[#f4efe4] hover:text-[#f5d685]"
                            >
                                {CONTACT.phone}
                            </a>
                            <a
                                href={WHATSAPP_URL}
                                target="_blank"
                                rel="noreferrer"
                                className="block text-[#f4efe4] hover:text-[#f5d685]"
                            >
                                {CONTACT.whatsapp}
                            </a>
                            <div className="text-[#b8b1a1]">
                                {CONTACT.fullAddress}
                            </div>
                            <div className="text-[#7d766a]">
                                {CONTACT.hours}
                            </div>
                        </div>
                    </div>

                    <div className="lg:col-span-2">
                        <div className="text-[10.5px] uppercase tracking-[0.28em] gold-text mb-4">
                            Yasal
                        </div>
                        <ul className="space-y-2.5 text-[13.5px]">
                            <li>
                                <Link
                                    to="/kvkk"
                                    className="text-[#c9c2b3] hover:text-[#f5d685]"
                                >
                                    KVKK
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/gizlilik"
                                    className="text-[#c9c2b3] hover:text-[#f5d685]"
                                >
                                    Gizlilik Politikası
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/cerez"
                                    className="text-[#c9c2b3] hover:text-[#f5d685]"
                                >
                                    Çerez Politikası
                                </Link>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="mt-12 pt-6 border-t border-[#23232b] flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-[11.5px] text-[#7d766a]">
                    <div>
                        © {new Date().getFullYear()} Cegu Masaj Salonu Özlüce ·
                        Tüm hakları saklıdır.
                    </div>
                    <div className="flex items-center gap-3">
                        <span>Bursa · Nilüfer · Özlüce</span>
                        <span className="text-[#7d766a]/50">·</span>
                        <a
                            href="https://wa.me/905324751871?text=Merhaba%2C%20web%20sitesi%20hakk%C4%B1nda%20bilgi%20almak%20istiyorum."
                            target="_blank"
                            rel="noreferrer"
                            data-testid="footer-mir-media"
                            className="inline-flex items-center gap-1.5 text-[#c9c2b3] hover:text-[#f5d685] transition"
                        >
                            <span className="text-[10px] uppercase tracking-[0.2em] text-[#7d766a]">
                                Project by
                            </span>
                            <span className="gold-text font-semibold tracking-wide">
                                Mir Media
                            </span>
                        </a>
                    </div>
                </div>
            </div>
        </footer>
    );
}
